import classNames from 'classnames'

import { useContentOverflow } from '../../../hooks'
import { FloatingTooltip } from '../../Floating'
import { TagTextLine } from '../TagTextLine'

import * as styles from './TagContent.module.css'

function TagContent({
  isFilled,
  secondText,
  text,
  textClassName = styles.text,
  textQaName,
  tooltip,
  tooltipPlacement,
  withMeta,
  withTooltip,
}) {
  const hasOuterTooltip = Boolean(tooltip)
  const outerTooltipEnabled = withTooltip && hasOuterTooltip
  const innerTooltipsEnabled = withTooltip && !hasOuterTooltip

  const { overflow: textOverflow, setContentOverflowRef: setTextOverflowRef } =
    useContentOverflow()
  const {
    overflow: secondTextOverflow,
    setContentOverflowRef: setSecondTextOverflowRef,
  } = useContentOverflow()

  return (
    <FloatingTooltip
      content={tooltip}
      disabled={!outerTooltipEnabled}
      placement={tooltipPlacement}
    >
      <div
        className={classNames(styles.content, {
          [styles.contentWithMeta]: withMeta,
        })}
      >
        <TagTextLine
          className={textClassName}
          overflowRef={setTextOverflowRef}
          placement={tooltipPlacement}
          qaName={textQaName}
          text={text}
          tooltipDisabled={!innerTooltipsEnabled || !textOverflow}
        />
        {secondText ? (
          <TagTextLine
            className={classNames(styles.secondText, {
              [styles.secondTextSlashed]: isFilled,
            })}
            overflowRef={setSecondTextOverflowRef}
            placement={tooltipPlacement}
            text={secondText}
            tooltipDisabled={!innerTooltipsEnabled || !secondTextOverflow}
          />
        ) : null}
      </div>
    </FloatingTooltip>
  )
}

export default TagContent
